import React, { FC } from 'react';

import { usePermissions } from '~/hooks';
import { useLocationsDelete } from '~/hooks/locations';
import { DeleteButton } from '~/components';

interface LocationDeleteProps {
  id: string;
  closeParent: () => void;
}

const LocationDelete: FC<LocationDeleteProps> = (props) => {
  const { id, closeParent } = props;

  const { mutate, isLoading } = useLocationsDelete(closeParent);

  const hasAccess = usePermissions('business.location.delete');
  if (!hasAccess) return null;
  return <DeleteButton onConfirm={() => mutate(id)} loading={isLoading} />;
};

export default LocationDelete;
